import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const CareerAdd = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [careerImg, setCareerImg] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddNewCareer = () => {
    navigate("/add-career");
  };

  const handleViewAllCareer = () => {
    navigate("/all-career");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    if (careerImg) {
      formData.append("careerImg", careerImg);
    }

    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/careerCategories`
        : `${API_BASE_URL}/admin/careerCategories`;

    try {
      const response = await axios.post(
        endpoint,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Career added successfully");
      console.log("Career added successfully:", response.data);

      navigate("/all-career");
    } catch (error) {
      console.error(
        "Error adding career:",
        error.response?.data || error.message
      );
      alert("Error adding career");
    }
  };

  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Career</h5>
            <div className="subjectdiv2">
              <button className="handleNewSubject" onClick={handleAddNewCareer}>
                + Add New Career
              </button>
              <button className="allSubjects" onClick={handleViewAllCareer}>
                All Career
              </button>
            </div>
          </div>

          <div className="form-sub-container mt-4" id="form">
            <h4 className="subject-detail">Career Details</h4>
            <form
              className="subject-detail-form"
              encType="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Title : </label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Title"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Description : </label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Image : </label>
                </div>
                <input
                  type="file"
                  id="subject-upload-icon"
                  multiple={false}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setCareerImg(file);
                    }
                  }}
                />
              </div>

              <div className="school-subj-form-btns">
                <button
                  className="btn-search"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button
                  className="btn-cancel"
                  type="button"
                  onClick={() => navigate("/all-career")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerAdd;
